import { parseEnv } from '@/helpers/route-utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod/v4';

export const Route = createFileRoute('/_auth/$env/experiments/')({
  validateSearch: zodValidator(
    z.object({
      search: z.string().optional().default(''),
      page: z.number().optional().default(1),
      pageSize: z.number().optional().default(10),
    }),
  ),
  params: parseEnv(),
});
